import { CashierManagementStatusEnum } from '../enum/cashier-management-status.enum';

export class CashierManagementParams {
    dateOpenStart: string;
    dateOpenFinal: string;
    userName: string;
    entityDescription: string;
    cashierManagementStatus: CashierManagementStatusEnum;
    currentPage: number;
    itemsPage: number;

    constructor() {
        this.dateOpenStart = '';
        this.dateOpenFinal = '';
        this.userName = '';
        this.entityDescription = '';
        this.cashierManagementStatus = CashierManagementStatusEnum.All;
        this.currentPage = 1;
        this.itemsPage = 15;
    }
}
